export const getCartFromStorage = () => {
    try {
        const cartData = localStorage.getItem('CARRITO_TIENDA_ONLINE');
        if (!cartData) return [];

        let parsed;
        try {
            parsed = JSON.parse(cartData);
        } catch (parseError) {
            console.error('Error parsing JSON from localStorage:', parseError);
            return null;
        }

        if (Array.isArray(parsed)) return parsed; // Formato antiguo: array directo

        if (parsed && Array.isArray(parsed.items)) return parsed.items; // Formato nuevo: objeto con `items`

        console.warn('Unexpected cart format:', parsed);
        return []; // Fallback para formatos no válidos
    } catch (error) {
        console.error('Error reading cart from localStorage:', error);
        return null;
    }
};

export const saveCartToStorage = (cart) => {
    try {
        // Ensure we're working with an array
        const itemsArray = Array.isArray(cart) ? cart : [];

        localStorage.setItem('CARRITO_TIENDA_ONLINE', JSON.stringify({
            items: itemsArray,
            lastUpdated: new Date().toISOString()
        }));
    } catch (error) {
        console.error('Error saving cart to localStorage:', error);
    }
};